import axiosInstanceSpotfinder from "./axiosInstanceSpotfinder";

const axiosBaseQuerySpotfinder =
  ({ baseUrl } = { baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }) =>
  async ({ url, method, body, params, headers ,responseType} :any) => {
    try {
      const result = await axiosInstanceSpotfinder({
        url: baseUrl + url,
        method,
        data:body,
        params,
        headers,
        responseType: responseType == undefined ? 'json' : responseType
      })
      console.log(result.data ,"result");
      return { data: result }
    } catch (axiosError) {
      const err:any = axiosError
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      }
    }
  }

  export default axiosBaseQuerySpotfinder;